import { postApi } from "@/utils/fetch";

export type SearchMansionRequest = {
  name: string;
};

export type SearchMansionResponse = {
  id: number;
  name: string;
  builtDate: string;
  address: {
    pref: string;
    city: string;
    town: string;
    street: string;
  };
  traffic: {
    line: string;
    station: string;
    bus: number;
    walk: number;
  };
};

export const searchMansion = async (
  abort: AbortController,
  params: SearchMansionRequest
): Promise<SearchMansionResponse[]> => {
  return postApi<SearchMansionResponse[]>("/api/search/mansions", {
    body: JSON.stringify(params),
  });
};

export type FetchMansionTrafficRequest = {
  mansionId: number;
};

export type FetchMansionTrafficResponse = {
  line: string;
  station: string;
  walk: number;
  bus: number;
};

export const fetchMansionTraffic = (abort: AbortController, params: FetchMansionTrafficRequest) => {
  return postApi<FetchMansionTrafficResponse[]>("/api/search/traffic", {
    body: JSON.stringify(params),
  });
};

export type FetchMansionUnitsRequest = {
  mansionId: number;
};

export type FetchMansionUnitsResponse = {
  id: number;
  mansionId: number;
  unitSize: number;
  balconyDirection: string;
  story: number;
  floorPlan: string;
  roomNumber: string;
  buildingName: string;
};

export const fetchMansionUnits = (abort: AbortController, params: FetchMansionUnitsRequest) => {
  return postApi<FetchMansionUnitsResponse[]>("/api/search/units", {
    body: JSON.stringify(params),
  });
};

export default {
  searchMansion,
  fetchMansionTraffic,
  fetchMansionUnits,
};
